<template>
    <el-calendar ref="calendar" v-loading="loading">
<!--        <template #date-cell="{data: _data}">-->
<!--            <div>{{ _data.day.split('-').slice(1).join('-') }}</div>-->
<!--            <div style="height: 70px;" @click="openDialog(_data.day)">-->
<!--                <el-image :src="`${get_image_cdn_url(d.thumbnail)}`" style="height: 30px;margin: 2px"-->
<!--                          v-for="d in data.filter(d=>d.online_date===_data.day&&d.module===1).sort((a, b) => a.sort < b.sort ?-1:1)"></el-image>-->
<!--            </div>-->
<!--        </template>-->
        <template #date-cell="{data: _data}">
          <div>{{ _data.day.split('-').slice(1).join('-') }}</div>
          <div style="height: 70px;" @click="openDialog(_data.day)">
            <img style="height: 30px;margin: 2px" :src="`${get_image_cdn_url(i.thumbnail)}`"
                 v-for="i in data_map[_data.day].slice(0, 8)" v-if="data_map[_data.day]">
          </div>
        </template>
    </el-calendar>
    <el-dialog v-model="dialog_opened" :before-close="reset" width="80%">
        <el-select v-model="country" filterable :disabled="loading" placeholder="全球">
          <el-option value="GLOBAL" label="GLOBAL"></el-option>
          <el-option v-for="c in $root.country_list" :value="c.code"
                     :label="c.en_name + ' (' + c.code + ')'"></el-option>
        </el-select>
        <el-select v-model="platform" filterable placeholder="请选择平台" :disabled="loading" style="width: 140px; margin-left: 10px">
          <el-option v-for="c in ['android', 'ios']" :value="c" :label="c"></el-option>
        </el-select>
        <vue-draggable-next v-model="dayImageList" :animation="300" handle=".handle" @change="sort">
          <transition-group>
            <div style="display: inline-block;position: relative;width: 140px;margin:5px" v-for="image in dayImageList">
              <el-image style="width: 140px;margin: 5px" lazy
                        :src="`${get_image_cdn_url(image.thumbnail)}`" class="handle"></el-image>
<!--              <el-image style="cursor: pointer;display: block" lazy-->
<!--                        :src="`${$root.env.CDN_URL}/${image.thumbnail}`" class="handle"></el-image>-->
              <b style="word-break: break-word">{{ image.id }}</b>
              <el-icon @click="offline(image)" size="20"
                       style="position: absolute; top: 5px; right: 5px;cursor: pointer;color: var(--el-color-danger)">
                <DeleteFilled/>
<!--                <CircleClose/>-->
              </el-icon>
<!--              <el-icon style="position: absolute; top: 5px; right: 5px;cursor: pointer;" @click="offline(image)">-->
<!--                <CircleClose/>-->
<!--              </el-icon>-->
              <el-icon @click="updateVideo(image)" size="20"
                       style="position: absolute;left: 10px;top: 110px;cursor: pointer">
                <Lock style="color: var(--el-color-primary)" v-if="image.video"/>
              </el-icon>
            </div>
          </transition-group>
        </vue-draggable-next>
        <el-divider></el-divider>
        <div>
          <el-select :disabled="loading" v-model="query.category" clearable filterable style="width: 200px"
                     placeholder="分类">
            <el-option v-for="c in category_list" :label="`${c.i18n_name.EN}(${c.i18n_name.ZH_HANS})`"
                       :value="c.id"></el-option>
          </el-select>
          <!--            <el-select :disabled="loading" v-model="query.type" clearable style="width: 100px" placeholder="类型">-->
          <!--                <el-option v-for="(v, k) in $root.image_type_enum" :label="v" :value="parseInt(k)"></el-option>-->
          <!--            </el-select>-->
          <el-select v-model="query.type" placeholder="类型" clearable style="width: 100px" :disabled="loading">
            <el-option v-for="(v, k) in image_type_enum" :label="v" :value="parseInt(k)"></el-option>
          </el-select>
          <el-select :disabled="loading" v-model="query.video" clearable style="width: 100px" placeholder="激励视频">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
          <el-select :disabled="loading" v-model="query.online" clearable style="width: 150px" placeholder="已选上线时间">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
          <el-input :disabled="loading" prefix-icon="Search" v-model="query.id" style="width: 200px" placeholder="ID"></el-input>
          <date-range-picker v-model="query" start-placeholder="上线开始时间" end-placeholder="上线结束时间"
                             :disabled="loading"></date-range-picker>
        </div>
        <el-table :data="dataPage" style="margin-top: 10px">
            <el-table-column label="预览图" prop="prefix" width="230">
                <template #default="scope">
                    <el-image lazy :src="`${get_image_cdn_url(scope.row.thumbnail)}`"
                              style="width: 100px"></el-image>
                    <el-image lazy :src="`${get_image_cdn_url(scope.row.finished)}`"
                              style="width: 100px"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="id" prop="nickname" width="60"></el-table-column>
            <el-table-column label="视频" prop="video" width="100">
              <template #default="scope">
                {{ scope.row.video ? '是' : '' }}
              </template>
            </el-table-column>
            <el-table-column label="状态" prop="status" width="120">
              <template #default="scope">
                    <span style="color: var(--el-color-success)"
                          v-if="scope.row.status === 4"> 已通过</span>
              </template>
            </el-table-column>
            <el-table-column label="类型" prop="type" width="60">
                <template #default="scope">
                    {{ image_type_enum[scope.row.type] }}
                </template>
            </el-table-column>
            <el-table-column label="色块" prop="cells" width="60"></el-table-column>
            <el-table-column label="难度" prop="difficulty" width="60">
                <template #default="scope">
                    <div v-if="scope.row.cells" :style="{color: scope.row.difficulty?'var(--el-color-error)':null}">
                        L{{ scope.row.cells > 800 ? 4 : scope.row.cells > 500 ? 3 : scope.row.cells > 300 ? 2 : 1 }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="分类" prop="categories" width="60">
                <template #default="scope">
                    <template v-for="c in scope.row.categories">
                        <template v-for="cc in category_list">
                            <el-tag size="small" v-if="cc.id===c">{{ cc.i18n_name.EN }}</el-tag>
                        </template>
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="角标" prop="tags" width="100">
                <template #default="scope">
                    <el-tag size="small" v-for="t in scope.row.tags">
                        {{ image_tag_enum[t] }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="预计上线" prop="online_date" width="160"></el-table-column>
            <el-table-column label="操作" width="100">
              <template #default="scope">
                <el-button type="primary" size="small" :disabled="scope.row.online_date === this.selected_day || loading"
                           @click="online(scope.row)">{{ scope.row.online_date === this.selected_day ? '已上线' : '上线' }}
                </el-button>
              </template>
            </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" :total="total" @current-change="fetchImages"
                       :page-size="limit"></el-pagination>
        <template #footer>
            <el-button type="primary" @click="reset" :disabled="loading">关闭</el-button>
        </template>
    </el-dialog>
</template>

<script>
import axios from "ts-axios-new";
import {VueDraggableNext} from 'vue-draggable-next'
// import {timestampToDate} from "../libs/utils";
import {isEmpty, timestampToDate} from "../libs/utils";
import {get_image_cdn_url} from "../libs/app";

export default {
    name: "Update",
    components: {VueDraggableNext},
    data() {
        return {
            loading: false, data: [], dialog_opened: false, category_list: [],
            image_type_enum: {1: '单色', 2: '彩绘'}, today: timestampToDate(Date.now()),
            country: "GLOBAL", platform: 'android',
            data_map: {}, day_image_list: [],  image_list: [],  total: 0, page: 1, skip: 0, limit: 50,
            selected_day: null, sort_list_map: {},
            query: this.createQuery(),
            image_tag_enum: {
                1: 'Special',
                2: 'Wallpaper',
                3: 'Collection',
                4: 'Artist',
                5: 'Music',
                6: 'Magic',
                7: 'Hot',
                8: 'Textured',
            },
            form: {
                date: '',
            }
        }
    },
    methods: {
      get_image_cdn_url,
        init() {
            this.loading = true;
            // axios.all([
            //     axios.get(`/cms/v1/image`).then(res => {
            //         this.data = res.data.data.imageList;
            //     }),
            //     axios.get('/cms/v1/category').then(res => {
            //         this.category_list = res.data.data.categoryList;
            //     }),
            // ]).then(_ => {
            //     this.loading = false;
            // })
            axios.all([
              axios.get(`/cms/v1/image`, {params: {module: 1}}).then(res => {
                this.image_list = res.data.data.imageList;
                this.total = res.data.data.total;
                this.formatData()
              }),
              axios.get('/cms/v1/category').then(res => {
                this.category_list = res.data.data.categoryList;
              }),
            ]).then(_ => {
              this.loading = false;
            })
        },
        formatData() {
          this.data_map = {}
          this.image_list.forEach(image => {
            if (image.online_date) {
              if (this.data_map[image.online_date]) {
                this.data_map[image.online_date].push(image);
              } else {
                this.data_map[image.online_date] = [image];
              }
            }
          });
          for (const date in this.data_map) {
            const images = this.data_map[date];
            if(images) {
              this.data_map[date] = images.sort(
                  (a, b) => (
                      (a?.sorts?.[this.sortType()] ?? a.sort ?? 0) - (b?.sorts?.[this.sortType()] ?? b.sort ?? 0)
                  )
              );
            }
          }
        },
        createQuery() {
          return {
            category:  null,
            module: 1,
            type: null,
            online: null,
            video: null,
            id: null,
            start: null,
            end: null,
          }
        },
        fetchImages(page) {
          this.skip = (page - 1) * this.limit;
          this.page = page
          this.total = this.imageList.length
        },
        reset() {
            this.loading = this.dialog_opened = false;
        },
        openDialog(day) {
          this.dialog_opened = true;
          this.sort_list_map = {}
          this.query = this.createQuery()
          this.selected_day = day;
          this.page = 1
          this.skip = 0
          this.day_image_list = []
          this.total = 0
          if (this.data_map[day]) {
            this.day_image_list = this.data_map[day]
          }
          this.total = this.imageList.length
        },
        online(image) {
          this.loading = true;
          if (image.online_date && this.data_map[image.online_date]) {
            this.data_map[image.online_date] = this.data_map[image.online_date].filter(i => i.id !== image.id);
          }
          image.online_date = this.selected_day;
          if (this.data_map[image.online_date]) {
            this.data_map[image.online_date].push(image)
          } else {
            this.data_map[image.online_date] = [image]
          }
          if (this.data_map[image.online_date]) {
            this.day_image_list = this.data_map[image.online_date]
          }
          this.sort_list_map = {}
          axios.put(`/cms/v1/image/${image.id}`, image).then(res => {
            // this.day_image_list.push(image)
            this.loading = false;
          })
        },
        offline(image) {
          this.loading = true;
          if (this.data_map[image.online_date]) {
            this.data_map[image.online_date] = this.data_map[image.online_date].filter(i => i.id !== image.id);
            this.day_image_list = this.data_map[image.online_date]
          }
          this.sort_list_map = {}
          image.online_date = null;
          axios.put(`/cms/v1/image/${image.id}`, image).then(res => {
            // this.day_image_list.splice(this.day_image_list.indexOf(image), 1);
            this.loading = false;
          })
        },
        updateVideo(row) {
          this.loading = true;
          row.video = !row.video;
          axios.put(`/cms/v1/image/${row.id}`, row).then(res => {
            this.loading = false;
          });
        },
        sort() {
          this.loading = true;
          const sort = [];
          this.dayImageList.forEach((d, i) => {
            sort.push(d.id)
            if(this.sortType() === "android-GLOBAL") {
              d.sort = i
            } else {
              if (d.sorts == null) {
                d.sorts = {}
              }
              d.sorts[this.sortType()] = i
            }
          });
          axios.post(`/cms/v1/sort/image`, {sort, sort_type: this.sortType()}).then(res => {
            this.loading = false;
          })
        },
        sortType() {
          return this.platform + "-" + this.country;
        },
    },
    mounted() {
        this.init();
    },
    computed: {
        // dataFilter() {
        //     return this.data.filter(d => {
        //         return d.status === 4 && [1].includes(d.module) && (!d.online_date || d.online_date >= this.today) && (!this.query || (d.nickname + '').includes(this.query) || d.authors.includes(this.query));
        //     })
        // },
      dataPage() {
        return this.imageList.slice(this.skip, this.skip + this.limit)
      },
      imageList() {
        return this.image_list.filter(
            item => (item.platform === null || item.platform === undefined || item.platform === "" || item.platform === this.platform) &&
                (!item.include_country || !item.include_country.length || item.include_country.includes(this.country)) &&
                (!item.exclude_country || !item.exclude_country.length || !item.exclude_country.includes(this.country)) &&
                (!item.online_date || item.online_date > this.selected_day) &&
                (item.status === 4) &&
                (!this.query.type && this.query.type !== 0 || item.type === this.query.type) &&
                (!this.query.category || item.categories.includes(this.query.category)) &&
                (!this.query.id || item.id === this.query.id) &&
                (!this.query.start || (item.online_date && item.online_date >= this.query.start)) &&
                (!this.query.end || (item.online_date && item.online_date <= this.query.end)) &&
                (!this.query.online || this.query.online && item.online_date && item.online_date < this.today || !this.query.online && (!item.online_date || item.online_date > this.today)) &&
                (!this.query.video || this.query.video === item.video))
            .sort((a, b) => {
              // const a_current = a.online_date === this.selected_day;
              // const b_current = b.online_date === this.selected_day;
              // if (a_current && !b_current) return -1;
              // if (!a_current && b_current) return 1;
              // if (isEmpty(a.online_date) && isEmpty(b.online_date)) {
              //   return (a?.sorts?.[this.sortType()] ?? a.sort ?? 0) - (b?.sorts?.[this.sortType()] ?? b.sort ?? 0);
              // }
              if (isEmpty(a.online_date) && isEmpty(b.online_date)) {
                if (a.nickname && b.nickname) {
                  return parseInt(b.nickname) - parseInt(a.nickname);
                } else {
                  return (a?.sorts?.[this.sortType()] ?? a.sort ?? 0) - (b?.sorts?.[this.sortType()] ?? b.sort ?? 0);
                }
              }
              if (isEmpty(a.online_date)) return -1;
              if (isEmpty(b.online_date)) return 1;
              if (a.online_date !== b.online_date) {
                return a.online_date < b.online_date ? -1 : 1;
              }
              return (a?.sorts?.[this.sortType()] ?? a.sort ?? 0) - (b?.sorts?.[this.sortType()] ?? b.sort ?? 0);
            });
      },
      dayImageList: {
        get() {
          if (!this.sort_list_map[this.sortType()]){
            const list = this.day_image_list.filter(
                item => ( (item.platform === null || item.platform === undefined || item.platform === this.platform) &&
                    (!item.include_country || !item.include_country.length || item.include_country.includes(this.country)) &&
                    (!item.exclude_country || !item.exclude_country.length || !item.exclude_country.includes(this.country))));
            this.sort_list_map[this.sortType()] = list.sort(
                (a, b) => (
                    (a?.sorts?.[this.sortType()] ?? a.sort ?? 0) - (b?.sorts?.[this.sortType()] ?? b.sort ?? 0)
                )
            );
          }
          return this.sort_list_map[this.sortType()]
        },
        set(value) {
          this.sort_list_map[this.sortType()] = value
        }
      }
    }
}
</script>

<style scoped>
.el-calendar ::v-deep(.el-calendar-day) {
    height: fit-content;
    width: 160px;
    min-height: var(--el-calendar-cell-width);
}

.el-select {
  width: 200px;
}

</style>